import React from 'react';
import styles from './styles.module.css';

import TickIcon from '../../../../icons/Tick';

export default () => (
  <div className={styles.container}>
    <TickIcon size={96} color="#56ad65" />
    <p>Your submission was successful</p>
    <p>We will review your submission and reply if required.</p>
  </div>
);



// WEBPACK FOOTER //
// ./src/page-components/contact-us/contact-form/submission-successful-stage/index.js